const { makeStyles } = require('@material-ui/core');

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1
  },
  menuIcon: {
    fill: '#1A2A33',
    transform: 'scale(1.5)'
  },
  list: {
    height: '100%',
    backgroundColor: '#EFEFEF',
    color: '#000000',
    [theme.breakpoints.up('sm')]: {
      width: '250px'
    },
    [theme.breakpoints.up('xs')]: {
      width: '200px'
    }
  },
  listItem: {
    marginTop: '0.5rem'
  }
}));

export default useStyles;
